import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.isDontWorkLpuWithExpress
    ? _c(_setup.AppointmentScreenWrapper, {
        attrs: { "data-qa": "appointment_dont_work" },
        scopedSlots: _vm._u(
          [
            {
              key: "main",
              fn: function () {
                return [
                  _c(
                    "div",
                    [
                      _c(VImg, {
                        staticClass: "mx-auto",
                        attrs: {
                          src: "/static/_v1/pd/pictures/ui-kit/clock.svg",
                          alt: "/",
                          width: "162",
                          height: "133",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "text-h6 text-text text-center mt-4" },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _setup.t(
                                  "Клиника сейчас не работает",
                                  _setup.options
                                )
                              ) +
                              ", "
                          ),
                          _c("br"),
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _setup.t("записаться можно", _setup.options)
                              ) +
                              " "
                          ),
                          _c("br"),
                          _vm._v(
                            "\n        " +
                              _vm._s(_setup.lpuData.nearestAppointmentExpress) +
                              "\n      "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "actions",
              fn: function ({ buttonProps }) {
                return [
                  _c(
                    VBtn,
                    _vm._b(
                      {
                        attrs: {
                          href: "/",
                          "data-qa": "appointment_success_first_button",
                        },
                      },
                      "v-btn",
                      buttonProps,
                      false
                    ),
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _setup.t("Перейти на главную", _setup.options)
                          ) +
                          "\n    "
                      ),
                    ]
                  ),
                ]
              },
            },
          ],
          null,
          false,
          3795601004
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }